<script lang="ts">
    import {onMount} from "svelte";

    export let url;

    onMount(() => {
    });


</script>
<div class="slack-inquiry-channel-link-view">
    <a target="_blank" rel="noreferrer noopenner" href={url}>
        <div class="content" title="Slackの問い合わせチャンネルが開きます">
            <img alt="slack" src="/img/slack.png"/>

        </div>

    </a>


</div>
<style lang="scss">
    .slack-inquiry-channel-link-view {
        position: fixed;
        right: 0;
        bottom: 0;

        .content {
            width: 40px;
            height: 40px;

            background-color: var(--background-color);
            padding-top: 24px;
            padding-left: 24px;
            padding-right: 12px;
            padding-bottom: 12px;
            border-top-left-radius: 100%;
            opacity: 0.5;
            cursor: pointer;
            filter: drop-shadow(2px 4px 6px black);
            transition-duration: 0.2s;
            transition-timing-function: linear;

            > img {
                width: 100%;
                height: 100%;
            }

            &:hover {
                opacity: 1;
                transform: scale(2);
                transform-origin: right bottom;
            }

        }

    }
</style>